// @flow
import React from 'react';
import styles from './ProceedToPayment.css';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip';

type OwnProps = {
  proceedToPayment: Function,
  selectedPlan: string,
  isTrialAvailable: boolean,
  trialDurationDays: number,
  isValentine26Campaign: boolean,
};

type Props = OwnProps;

const ProceedToPayment = ({
  proceedToPayment,
  selectedPlan,
  isTrialAvailable,
  trialDurationDays,
  isValentine26Campaign,
}: Props) => {
  const ButtonText = () => {
    if (isValentine26Campaign) {
      return (
        <FormattedMessage
          id="premium.payment-form.submit-btn.valentine26"
          defaultMessage="Try it for {trialDurationMonths} months"
          values={{ trialDurationMonths: Math.ceil(trialDurationDays / 30) }}
        />
      );
    }
    if (isTrialAvailable) {
      return (
        <FormattedMessage
          id="premium.payment-form.submit-btn.start-my-trial"
          defaultMessage="Start my {trialDurationDays}-day free trial"
          values={{ trialDurationDays }}
        />
      );
    }
    return (
      <FormattedMessage
        id="premium.plan-summary.btn.proceed-to-checkout"
        defaultMessage="Proceed to Checkout"
      />
    );
  };
  return (
    <div className={styles.container} data-test="proceed-to-payment">
      <button
        className={classNames('c-btn c-btn--is-inverted', styles.btn)}
        onClick={proceedToPayment}
        disabled={!selectedPlan}
        data-tip
        data-for="proceed-to-payment"
        data-test="proceed-to-payment.btn"
      >
        <ButtonText />
      </button>
      {!selectedPlan && (
        <ReactTooltip className={styles.tooltip} id="proceed-to-payment" effect="solid" place="top">
          <FormattedMessage
            id="premium.plan-summary.tooltip.continue"
            defaultMessage="Please select a plan to continue"
          />
        </ReactTooltip>
      )}
    </div>
  );
};

export default ProceedToPayment;
